import { numberToPrettyString } from '@cian/utils';

import { ECoworkingOfferType, IOffer } from '../../../types/offer';

const COWORKING_WORKPLACE_TYPES: ReadonlySet<ECoworkingOfferType> = new Set([
  ECoworkingOfferType.Office,
  ECoworkingOfferType.FixedWorkplace,
  ECoworkingOfferType.FlexibleWorkplace,
]);

function isCoworkingWorkplacePrice(offer: IOffer): boolean {
  return Boolean(offer.coworkingOfferType && COWORKING_WORKPLACE_TYPES.has(offer.coworkingOfferType));
}

export function getCommercialPriceMain(offer: IOffer): string {
  const { dealType, bargainTerms, minPriceTotalRur, minPriceTotalPerMonthRur, priceTotalPerMonthRur } = offer;

  if (dealType === 'rent') {
    if (isCoworkingWorkplacePrice(offer)) {
      const workplace = bargainTerms?.priceForWorkplace || priceTotalPerMonthRur || minPriceTotalPerMonthRur || 0;
      const pretext =
        !bargainTerms?.priceForWorkplace && !priceTotalPerMonthRur && minPriceTotalPerMonthRur ? 'от ' : '';

      return `${pretext}${numberToPrettyString(workplace)} ₽/мес. за рабочее место`;
    }

    const monthly = priceTotalPerMonthRur || minPriceTotalPerMonthRur || bargainTerms?.priceRur || 0;
    const pretext = minPriceTotalPerMonthRur && !priceTotalPerMonthRur ? 'от ' : '';

    return `${pretext}${numberToPrettyString(monthly)} ₽/мес.`;
  }

  const sale = bargainTerms?.priceRur || minPriceTotalRur || 0;
  const pretext = minPriceTotalRur && !bargainTerms?.priceRur ? 'от ' : '';

  return `${pretext}${numberToPrettyString(sale)} ₽`;
}
